import * as React from 'react';

// HORO-10509: added viewBox — without it, passing a custom width/height
// (e.g. width={18} height={18} for the compact Sign in OAuth row) redefines
// the SVG's own coordinate space instead of scaling the artwork, clipping
// the G down to whatever fraction of the original 32x32 the new size covers.
const GoogleLoginIcon = (props) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
        <path
            fill="#F0BE42"
            d="M31.688 12.866H30.4V12.8H16v6.4h9.042c-1.32 3.725-4.864 6.4-9.042 6.4-5.302 0-9.6-4.299-9.6-9.6 0-5.302 4.298-9.6 9.6-9.6 2.447 0 4.673.923 6.369 2.431l4.525-4.525C24.037 1.642 20.214 0 16 0 7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16c0-1.073-.11-2.12-.312-3.134Z"
        />
        <path
            fill="#D7503F"
            d="M1.844 8.553 7.1 12.408C8.523 8.886 11.968 6.4 16 6.4c2.447 0 4.673.923 6.368 2.431l4.526-4.525C24.035 1.642 20.213 0 15.999 0 9.853 0 4.524 3.47 1.844 8.553Z"
        />
        <path
            fill="#58A65C"
            d="M16 32c4.132 0 7.888-1.582 10.727-4.154l-4.952-4.19A9.528 9.528 0 0 1 16 25.6c-4.162 0-7.695-2.654-9.027-6.357l-5.217 4.02C4.404 28.445 9.78 32 16 32Z"
        />
        <path
            fill="#5383EC"
            d="M31.689 12.866h-1.29V12.8H16v6.4h9.042a9.632 9.632 0 0 1-3.27 4.457l.003-.002 4.952 4.19C26.377 28.164 32 24 32 16c0-1.073-.11-2.12-.311-3.134Z"
        />
    </svg>
);
export default GoogleLoginIcon;
